// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_RegistrarContatoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /retomada/registrar_contato (chamado 2026-0052).
 *
 * O contato com um cliente da retomada: o clique no botao do WhatsApp ('whatsapp') ou a
 * marcacao "ja contatado" ('manual'). A linha da retomada e (cliente, categoria), entao o
 * contato tambem e.
 */
import { registerContract } from './validate'

export interface Retomada_RegistrarContatoInput {
cliente_id: number
servicoscategoria_id: number
canal: string
}

registerContract('Retomada_RegistrarContatoInput', {
  cliente_id:           { type: 'number',  required: true },
  servicoscategoria_id: { type: 'number',  required: true },
  canal:                { type: 'string',  required: true },
})
